import { render } from "./SelectIdentityType.vue?vue&type=template&id=17889270&ts=true"
import script from "./SelectIdentityType.vue?vue&type=script&lang=ts"
export * from "./SelectIdentityType.vue?vue&type=script&lang=ts"

import "./SelectIdentityType.vue?vue&type=style&index=0&id=17889270&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/prod_electronic-delivery-responsive_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__